import api from "./api";

class ClaimsV3DataService {
  // Dashboard (table rows + counts)
  dashboard(params = {}) {
    return api.get("/claimsV3/dashboard", { params });
  }

  // List claims (paginated, filtered)
  getAll(params = {}) {
    return api.get("/claimsV3", { params });
  }

  // Single claim with notes
  get(id) {
    return api.get(`/claimsV3/${id}`);
  }

  // Create claim (adjuster submits)
  create(data) {
    return api.post("/claimsV3", data);
  }

  // Update claim fields (manager/payroll)
  update(id, data) {
    return api.put(`/claimsV3/${id}`, data);
  }

  // Transition claim status
  updateStatus(id, data) {
    return api.put(`/claimsV3/${id}/status`, data);
  }

  // Editor disclaimer verification
  verify(id, data) {
    return api.post(`/claimsV3/${id}/verify`, data);
  }

  // Communication notes
  addNote(id, message) {
    return api.post(`/claimsV3/${id}/notes`, { message });
  }

  getNotes(id) {
    return api.get(`/claimsV3/${id}/notes`);
  }

  // Duplicate detection (Payroll Manager)
  getDuplicates() {
    return api.get("/claimsV3/duplicates");
  }

  resolveDuplicate(id, action = "mark-legitimate") {
    return api.put(`/claimsV3/${id}/resolve-duplicate`, { action });
  }

  // Delete claim
  delete(id) {
    return api.delete(`/claimsV3/${id}`);
  }

  // Batch delete claims (archive cleanup - manager/payroll manager only)
  batchDelete(ids) {
    return api.post("/claimsV3/batch-delete", { ids });
  }

  // Export styled XLSX (via backend ExcelJS)
  exportXlsx(data) {
    return api.post("/claimsV3/export-xlsx", data, { responseType: "blob" });
  }

  // Export styled DOCX (via backend docx library)
  exportDocx(data) {
    return api.post("/claimsV3/export-docx", data, { responseType: "blob" });
  }
}

export default new ClaimsV3DataService();
